import React, { useState, useCallback, useEffect } from 'react';
import _ from 'lodash';

const MAX_AMOUNT = '999999999999.99';

const VALID_RULES = [
  'password',
  'required',
  'number',
  'date',
  'required_if',
  'tin_number',
  'mobile_number',
  'telephone_number',
  'array',
  'object',
  'rptax_tdn',
  'rptax_pin',
  'rptax_pin_short',
  'btax_bin',
  'amount',
  'email',
  'min_six',
  'drivers_license_number',
  'same',
  'min_eight',
  'letters_only',
  'text_vapt',
  'maximum',
  'service_type'
];

const ucWords = (value) => {
  return value
    .replace('_code', '')
    .replace('_id', '')
    .replace(/_+/g, ' ')
    .split(/\s/)
    .map((w) => {
      const [first, ...rest] = w;

      return `${first.toUpperCase()}${rest.join('')}`;
    })
    .join(' ');
};

export const  inputHelperMessage = (response, field) => {
  // const rules = object_rules[field] || []

  // const hasRequired = rules.split(/\|/g).indexOf('required') > -1
  // const value = data[field]

  if (!_.isEmpty(response)) {
    return response.data[field] && !response.data[field].is_passed ? (
      <>
        {response.data[field].generic_message[0] === 'Required' ? <span className="font-bold font-md text-red-600">*</span> :
        <small
          className="bg-info text-white px-2 font-light rounded-t rounded-r"
        >
          {response.data[field].generic_message[0]}
        </small>}
      </>
    ) : (
      <span className="inline-flex">&nbsp;</span>
      // <Icon.BoxCheck className="inline-flex"/>
    );
  }

  return null;
};

export default (data = {}, init_object_rules = {}, message_settings = {}) => {
  const [response, setResponse] = useState({});
  const [object_rules, setObjectRules] = useState(init_object_rules)
  
  const onSetObjectRules = (newRules) => {
    setObjectRules(newRules)
  }
  
  useEffect(() => {
    validate()
    // eslint-disable-next-line
  }, [Object.values(data).join(','), object_rules])

  if (Array.isArray(data)) {
    throw new Error(
      `Invalid data argument type should be object, received an array`
    );
  }

  if (typeof data !== 'object') {
    throw new Error(
      `Invalid data argument type should be object, received an ${typeof data}`
    );
  }

  if (Array.isArray(object_rules)) {
    throw new Error(
      `Invalid object_rules argument type should be object, received an array`
    );
  }

  if (typeof object_rules !== 'object') {
    throw new Error(
      `Invalid object_rules argument type should be object, received an ${typeof object_rules}`
    );
  }

  if (Array.isArray(message_settings)) {
    throw new Error(
      `Invalid message_settings argument type should be object, received an array`
    );
  }

  if (typeof message_settings !== 'object') {
    throw new Error(
      `Invalid message_settings argument type should be object, received an ${typeof message_settings}`
    );
  }

  const ruleEntries = Object.entries(object_rules);

  const validateRule = (field, rule_pattern) => {
    const fieldUCWords = ucWords(field);

    const value = data[field];

    const [rule, args] = rule_pattern.split(/:/);

    if (VALID_RULES.indexOf(rule) < 0) {
      throw new Error(`${rule} is not valid rule`);
    }

    const fieldOnMessage =
      message_settings[field] && message_settings[field][rule]
        ? message_settings[field][rule]
        : fieldUCWords;

    if (rule === 'required') {
      if ((typeof value === 'string' && !value.toString().trim()) || !value) {
        return {
          field,
          is_passed: false,
          generic_message: 'Required',
          message: `${fieldOnMessage} field is Required`,
        };
      }

      if (typeof value === 'number' && value === '') {
        return {
          field,
          is_passed: false,
          generic_message: 'Required',
          message: `${fieldOnMessage} field is Required`,
        };
      }
      if (value === false) {
        return {
          field,
          is_passed: false,
          generic_message: 'Required',
          message: `${fieldOnMessage} field is Required`,
        };
      }

      if (Array.isArray(value) && value.length === 0) {
        return {
          field,
          is_passed: false,
          generic_message: 'Required',
          message: `${fieldOnMessage} field is Empty`,
        };
      }
    }

    if (rule === 'number') {
      if (value && !/^\d*(\.\d{1,4})?$/.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: 'Must be a Number',
          message: `${fieldOnMessage} field is invalid format, should be number`,
        };
      }
    }

    if (rule === 'password') {

      if (value && !/^.{8,}$/.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: 'shoud atleast 8 characters',
          message: `${fieldOnMessage} shoud atleast 8 characters`,
        };
      }

      if (value && !/^(?=.*[A-Z]).{8,}$/.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: 'must include both upper and lower case letters',
          message: `${fieldOnMessage} must include both upper and lower case letters`,
        };
      }

      if (value && !/^(?=.*[0-9]).{8,}$/.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: 'atleast one number',
          message: `${fieldOnMessage} and atleast one number`,
        };
      }

      // if (value && !/^(?=.*[A-Z])(?=.*[0-9]).{8,}$/.test(value)) {
      //   return {
      //     field,
      //     is_passed: false,
      //     generic_message: 'must include both upper and lower case letters and atleast one number',
      //     message: `${fieldOnMessage} must include both upper and lower case letters and atleast one number`,
      //   };
      // }
    }

    if (rule === 'letters_only') {
      if (value && !/^[a-zA-Z.ñÑ ]*$/.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: 'Must contain a word charater only',
          message: `${fieldOnMessage} Must contain a word charater only`,
        };
      }
    }

    if (rule === 'email') {
      if (value && !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: 'Must be a valid Email',
          message: `${fieldOnMessage} is Invalid`,
        };
      }
    }

    if (rule === "text_vapt") {
      if (value && !/^[a-zA-Z.ñÑ ]*$/.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: "Invalid format",
          message: `${fieldOnMessage} field is invalid format.`,
        };
      }
    }

    if (rule === 'amount') {
      if (value && +value > MAX_AMOUNT) {
        return {
          field,
          is_passed: false,
          generic_message: `Invalid Amount, should be between 1.00 to ${parseFloat(
            MAX_AMOUNT
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
          message: `${fieldOnMessage} field is invalid amount, should be between 1.00 to ${parseFloat(
            MAX_AMOUNT
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
        };
      }
    }

    if (rule === 'rptax_tdn') {
      if (value && !/^\w{2,2}-\d{5,5}-\d{5,5}$/.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: 'Invalid format, should be AA-00000-00000',
          message: `${fieldOnMessage} field is invalid format, should be AA-00000-00000`,
        };
      }
    }

    if (rule === 'rptax_pin') {
      if (
        value &&
        !/^\d{3,3}-\d{2,2}-\d{3,3}-\d{3,3}-\d{3,3}-[\w\d]{5,5}$/.test(value)
      ) {
        return {
          field,
          is_passed: false,
          generic_message: 'Invalid format, should be 000-00-000-000-000-AAAAA',
          message: `${fieldOnMessage} field is invalid format, should be 000-00-000-000-000-AAAAA`,
        };
      }
    }

    if (rule === 'min_six') {
      if (value && !/^.{6,}$/.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: 'Invalid format, should be minimum of 6 characters',
          message: `${fieldOnMessage} field is invalid format, id length must be greater that 6 digits`,
        };
      }
    }

    if (rule === 'min_eight') {
      if (value && !/^.{8,}$/.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: 'Invalid format, should be minimum of 8 characters',
          message: `${fieldOnMessage} Invalid format, should be minimum of 8 characters`,
        };
      }
    }

    if (rule === 'rptax_pin_short') {
      if (value && !/^\d{3,3}-\d{2,2}-\d{3,3}-\d{3,3}-\d{3,3}$/.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: 'Invalid format, should be 000-00-000-000-000',
          message: `${fieldOnMessage} field is invalid format, should be 000-00-000-000-000`,
        };
      }
    }

    if (rule === 'btax_bin') {
      if (value && !/^\d{3,3}-\d{2,2}-\d{4,4}-\d{7,7}$/.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: 'Invalid format, should be 000-00-0000-0000000',
          message: `${fieldOnMessage} field is invalid format, should be 000-00-0000-0000000`,
        };
      }
    }

    if (rule === 'array') {
      if (value && !Array.isArray(value)) {
        return {
          field,
          is_passed: false,
          generic_message: 'Must be a List',
          message: `${fieldOnMessage} field is invalid format, should be List`,
        };
      }
    }

    if (rule === 'date') {
      if (value && !/^\d{4,4}-\d{2,2}-\d{2,2}$/.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: 'Must be a Date (MM/DD/YYYY)',
          message: `${fieldOnMessage} field is invalid format, should be MM/DD/YYYY`,
        };
      }
    }

    if (rule === 'maximum') {
      if (value && +value > args) {
        return {
          field,
          is_passed: false,
          generic_message: `Remaining units: ${args}`,
          message: `${fieldOnMessage} field is invalid amount, maximum of ${args}`,
        };
      }
    }

    if (rule === 'service_type') {
      if (value && !/^.{0,100}$/.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: 'Maximum of 100 characters',
          message: `${fieldOnMessage} field is invalid format, maximum of 100 characters`,
        };
      }

    }

    if (rule === 'required_if' || rule === 'same') {
      
      // format fieldconditionvalue sample field=OTHER
      const fieldConditionValue = new RegExp(/^\w+(=|>|<|!=|~){1,1}[\w\W]+$/);
      if (rule === 'required_if' && !fieldConditionValue.test(args)) {
        throw new Error(
          'Invalid required_if rules argument, sample target_field=value or target_field!=value'
        );
      }

      const [targetField, targetCondition, targetValue] = args.split(
        /(=|>|<|!=|~){1,1}/
      );

      const fieldValue = data[targetField];
      const fieldValueTypeIsString = typeof fieldValue === 'string';
      const fieldValueTypeIsNumber = typeof fieldValue === 'number';
      const targetFieldUCWords = ucWords(targetField);

      const targetFieldUCWordsOnMessage =
        message_settings[targetField] && message_settings[targetField].required
          ? message_settings[targetField].required
          : targetFieldUCWords;

      const targetValueOnMessage =
        message_settings[targetField] &&
        message_settings[targetField].required_if_value
          ? message_settings[targetField].required_if_value
          : targetValue;

      if(rule === 'same' && fieldValue !== value){
        return {
          field,
          is_passed: false,
          generic_message: `${fieldUCWords} should be equal to ${targetFieldUCWordsOnMessage}`,
          message: `${fieldOnMessage} field is required, when ${targetFieldUCWordsOnMessage} is ${targetValueOnMessage}`,
        };
      }

      if(rule === 'required_if'){

        if (
          fieldValue === +targetValue &&
          targetCondition === '=' &&
          !value &&
          targetValueOnMessage === 'none'
        ) {
          return {
            field,
            is_passed: false,
            generic_message: 'Required',
            message: `${fieldOnMessage} field is Required`,
          };
        }

        if (
          fieldValueTypeIsString &&
          fieldValue === targetValue &&
          targetCondition === '=' &&
          !value
        ) {
          return {
            field,
            is_passed: false,
            generic_message: `Required, when ${targetFieldUCWordsOnMessage} is ${targetValueOnMessage}`,
            message: `${fieldOnMessage} field is required, when ${targetFieldUCWordsOnMessage} is ${targetValueOnMessage}`,
          };
        }

        if (
          fieldValueTypeIsNumber &&
          fieldValue === +targetValue &&
          targetCondition === '=' &&
          !value
        ) {
          return {
            field,
            is_passed: false,
            generic_message: `Required, when ${targetFieldUCWordsOnMessage} is ${targetValueOnMessage}`,
            message: `${fieldOnMessage} field is required, when ${targetFieldUCWordsOnMessage} is ${targetValueOnMessage}`,
          };
        }

        if (
          fieldValueTypeIsString &&
          fieldValue !== targetValue &&
          targetCondition === '!=' &&
          !value
        ) {
          return {
            field,
            is_passed: false,
            generic_message: `Required, when ${targetFieldUCWordsOnMessage} is not ${targetValueOnMessage}`,
            message: `${fieldOnMessage} field is required, when ${targetFieldUCWordsOnMessage} is not ${targetValueOnMessage}`,
          };
        }

        if (
          fieldValueTypeIsNumber &&
          fieldValue !== targetValue &&
          targetCondition === '!=' &&
          !value
        ) {
          return {
            field,
            is_passed: false,
            generic_message: `Required, when ${targetFieldUCWordsOnMessage} is equal to ${targetValueOnMessage}`,
            message: `${fieldOnMessage} field is required, when ${targetFieldUCWordsOnMessage} is not equal to ${targetValueOnMessage}`,
          };
        }

        if (
          targetValue.split(/,/g).indexOf(fieldValue) > -1 &&
          targetCondition === '~' &&
          !value
        ) {
          return {
            field,
            is_passed: false,
            generic_message: `Required, when ${targetFieldUCWordsOnMessage} is equal to ${targetValueOnMessage}`,
            message: `${fieldOnMessage} field is required, when ${targetFieldUCWordsOnMessage} is in ${targetValueOnMessage}`,
          };
        }
      }
    }

    if (rule === 'tin_number') {
      const regex = new RegExp(/\d{3,3}-\d{3,3}-\d{3,3}-\d{5,5}/);

      if (value && !regex.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: 'Invalid format, should be 000-000-000-00000',
          message: `${fieldOnMessage} field is invalid format, should be 000-000-000-00000`,
        };
      }
    }

    if (rule === 'drivers_license_number') {
      const regex = new RegExp(/\w{1,1}\d{2,2}-\d{2,2}-\d{6,6}/);

      if (value && !regex.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: 'Invalid format, should be A00-00-000000',
          message: `${fieldOnMessage} field is invalid format, should be A00-00-000000`,
        };
      }
    }

    if (rule === 'mobile_number') {
      const regex = new RegExp(/^09\d{9,9}$/);

      if (value && !regex.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: `Invalid format, should be 09000000000`,
          message: `${fieldOnMessage} field is invalid format, should be 09000000000`,
        };
      }
    }

    if (rule === 'telephone_number') {
      const regex = new RegExp(/^\d{7,7}$/);

      if (value && !regex.test(value)) {
        return {
          field,
          is_passed: false,
          generic_message: `Invalid format, should be 0000000`,
          message: `${fieldOnMessage} field is invalid format, should be 0000000`,
        };
      }
    }

    return {
      field,
      is_passed: true,
    };
  };

  const process = () => {
    const validateRuleResponse = ruleEntries.map((ruleEntry) => {
      const [field, perItemArrayRules] = ruleEntry;

      const perItemArrayRulesArray = perItemArrayRules.split(/\|/g);

      return perItemArrayRulesArray.map((ruleItem) =>
        validateRule(field, ruleItem)
      );
    });

    const is_passed = validateRuleResponse
      .map((ruleResponse) => ruleResponse.every((item) => item.is_passed))
      .every((isPassed) => isPassed);

    const responseData = validateRuleResponse.reduce(
      (accumulator, currentValue, i) => {
        const checkIsPassed = currentValue
          .map((curr) => curr.is_passed)
          .every((isPassed) => isPassed);

        return {
          ...accumulator,
          [ruleEntries[i][0]]: {
            is_passed: checkIsPassed,
            generic_message: !checkIsPassed
              ? currentValue
                  .filter((is_null) => is_null.generic_message)
                  .map((curr) => curr.generic_message)
              : [],
            message: !checkIsPassed
              ? currentValue
                  .filter((is_null) => is_null.message)
                  .map((curr) => curr.message)
              : [],
          },
        };
      },
      {}
    );

    return {
      is_passed,
      data: responseData,
    };
  };

  const showFirstErrorMessage = () => {
    const responceProcess = process();

    const firstMessage = Object.entries(responceProcess.data)
      .filter((item) => !item[1].is_passed)
      .filter((x, i) => i === 0)
      .reduce((x, current) => current[1].message, true);

    return firstMessage === true ? true : firstMessage[0];
  };

  const validate = () => {
    setResponse(process());
  };

  const renderMessage = useCallback((field) => inputHelperMessage(response, field), [response])

  // const renderMessage = (field) => {
  //   // const rules = object_rules[field] || []

  //   // const hasRequired = rules.split(/\|/g).indexOf('required') > -1
  //   // const value = data[field]

  //   if (!_.isEmpty(response)) {
  //     return response.data[field] && !response.data[field].is_passed ? (
  //       <small
  //         className="bg-info text-white px-2 font-light rounded-t rounded-r"
  //         style={{ fontSize: 10 }}
  //       >
  //         {response.data[field].generic_message[0]}
  //       </small>
  //     ) : (
  //       <Icon.BoxCheck className="inline-flex"/>
  //     );
  //   }

  //   return null;
  // };

  return { response, validate, showFirstErrorMessage, renderMessage, onSetObjectRules };
};
